import ilComponent from './PaperSelect'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}

